import React, { FC } from "react";
import { FilmmakersProfile } from "assets";
import LogoBaseLink from "./LogoBaseLink";

const FilmmakersProfileWebsiteLogoLink: FC<
  React.PropsWithChildren<{
    href: string;
    tabIndex: number;
  }>
> = ({ href, tabIndex }) => {
  return (
    <LogoBaseLink href={href} tabIndex={tabIndex}>
      <FilmmakersProfile />
    </LogoBaseLink>
  );
};

export default FilmmakersProfileWebsiteLogoLink;
